<modal-form-container
  [title]="title"
  className="md:w-[720px] lg:w-[760px]"
  [showModal]="open"
  (closeModalEvent)="closeModal()"
>
  @if (open) {
    <div class="pk">
      <bk-group-picker kind="tag" [selected]="draft" (selectedChange)="onPick($any($event))" />

      <div class="pk__foot">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="closeModal()">Cancel</button>
        <!-- With nothing ticked the button clears what the message had; with nothing before either, there is nothing to do. -->
        <button
          type="button"
          class="bk-btn bk-btn--primary"
          [disabled]="!draft.length && !selection.length"
          (click)="emitSelection()"
        >
          {{ draft.length ? "Use " + draft.length + " selected" : selection.length ? "Clear tags" : "Use selected" }}
        </button>
      </div>
    </div>
  }
</modal-form-container>
